const autoAssign = {
  en: {
    autoAssign: {
      labels: {
        name: {
          title: "Rule Name"
        },
        priority: {
          title: "Priority"
        },
        outlet_groups: {
          title: "Outlet Groups",
          placeholder: "Select Outlet Groups"
        },
        action: 'Actions',
        filter: 'Filters',
        languages:{
          title: "Languages",
          placeholder: "Select Languages"
        },
        social_media_platforms: {
          title: 'Social Media Platform',
          placeholder: 'Social Media Platforms'
        },
        account_type: {
          title: 'Account Type',
          placeholder: 'Account Types'
        },
        post_types: {
          title: 'Include Post Type',
          placeholder: 'Include Post Types'
        },
        exclude_post_types: {
          title: 'Exclude Post Type',
          placeholder: 'Exclude Post Types'
        },
        minimum_followers: {
          title: 'Minimum number of followers',
          placeholder: 'Minimum number of followers'
        },
        include_handle: {
          title: 'Include Handle',
          placeholder: 'Include Handle',
          add_include_handle: 'Add Include Handle'
        },
        exclude_handle: {
          title: 'Exclude Handle',
          placeholder: 'Exclude Handle',
          add_exclude_handle: 'Add Exclude Handle'
        },
        user_locations: {
          title: 'User Location',
          placeholder: 'User Location'
        }
      },
      form: {
        save: "Save",
        create: {
          title: "Add Auto-Filter Rule",
          add: "Add Rule"
        },
        edit: {
          title: "Edit Auto-Filter Rule",
        }
      }
    }
  }
}

module.exports.autoAssign = autoAssign;